import { Component } from "@angular/core";

@Component({
  selector: "app-prescription-header",
  templateUrl: "./prescription-header.component.html",
  styleUrls: ["./prescription-header.component.css"],
})
export class PrescriptionHeaderComponent {
  printPage() {
    window.print();
  }
}
